export enum ReviewStatus {
    notReviewed = 1,
    inProgress = 2,
    reviewed = 3,
}
